import { useState } from "react";
import "./VerifyTitle.css";
// import { indianLanguages } from "../../utils/MockInputData"; // Assuming these are arrays
import { statesWithCodes } from "../../utils/MockInputData";
import RenderResponse from "../RenderResponse/RenderResponse";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

const VerifyTitle = () => {
  const [formState, setFormState] = useState({
    title: "",
    state: "",
    languages: [],
  });

  const [results, setResults] = useState(null);
  const [error, setError] = useState("");
  const [titleError, setTitleError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormState({ ...formState, [name]: value });
    if (name === "title" && value.trim() !== "") {
      setTitleError(false); // Clear error if title is entered
    }
  };

  const handleStateChange = (event, newValue) => {
    if (newValue === null || newValue === undefined) {
      setFormState({ ...formState, ["state"]: "" });
      return;
    }
    setFormState({ ...formState, ["state"]: newValue?.code });
    // console.log("Selected State:", newValue.code); // Logs the selected state object
  };

  const handleMultiSelectChange = (event) => {
    const { value } = event.target;
    setFormState({
      ...formState,
      languages: typeof value === "string" ? value.split(",") : value,
    });
  };

  const handleClear = () => {
    // setFormState({ title: "", state: "" });
    setFormState({ title: "", state: "", languages: [] });
    setError("");
    setTitleError(false); // Reset error state
    setResults(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    if (formState.title.trim() === "") {
      setTitleError(true); // Set error if title is empty
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://ajayreddy9-prgi.hf.space/verify-title/?new_title=${formState.title}&distance_threshold=80`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setLoading(false);
      setResults(data.results);
      // console.log(data);
    } catch (e) {
      setLoading(false);
      setError(e.message);
      console.log(e.message);
    }
  };

  return (
    <section className="verify-title-page">
      <h1>Verify Your Title</h1>
      <div className="form-container">
        <Box
          component="form"
          fullWidth
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: "1rem 2rem",
            margin: "0 auto",
            maxWidth: "1000px",
          }}
        >
          {/* Inputs in a row */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "space-between",
            }}
          >
            <TextField
              label="Title Name"
              name="title"
              value={formState.title}
              onChange={handleInputChange}
              error={titleError}
              helperText={titleError ? "Title is required" : ""}
              required
              sx={{ flex: 1 }} // Make the input fields share equal width
            />

            {/* <FormControl sx={{ flex: 1 }}>
              <InputLabel id="state-label">State</InputLabel>
              <Select
                labelId="state-label"
                id="state-select"
                value={formState.state}
                label="State"
                name="state"
                onChange={handleInputChange}
              >
                {statesWithCodes.map((state, index) => (
                  <MenuItem key={index} value={state.code}>
                    {state.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl sx={{ flex: 1 }}>
              <Autocomplete
                options={statesWithCodes}
                getOptionLabel={(option) => option.name} // Display state name in dropdown
                onChange={handleStateChange} // Handle state selection
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select State"
                    variant="outlined"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.code === value.code
                } // Ensure proper value matching
              />
            </FormControl>
            {/* <FormControl sx={{ flex: 1 }}>
              <InputLabel id="language-label">Language</InputLabel>
              <Select
                labelId="language-label"
                multiple
                name="languages"
                value={formState.languages}
                onChange={handleMultiSelectChange}
                input={<OutlinedInput label="Language" />}
                renderValue={(selected) => selected.join(", ")}
              >
                {indianLanguages.map((language) => (
                  <MenuItem key={language} value={language}>
                    <Checkbox
                      checked={formState.languages.indexOf(language) > -1}
                    />
                    <ListItemText primary={language} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </Box>

          {/* Buttons below the inputs */}
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button variant="outlined" color="secondary" onClick={handleClear}>
              Clear
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Check
            </Button>
          </Box>
          {error !== "" && <p class="error-message">{error} </p>}
        </Box>

        <div className="responses-container">
          {loading && <div className="loading-container">loading</div>}
          {!loading && results != null && (
            <RenderResponse
              results={results}
              state={formState.state.toLowerCase()}
              languages={formState.languages}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default VerifyTitle;
